const Constants = {
  caseLawDocumentTypePath: "/case-law-documents/types",
  caseLawDocumentPath: "/case-law-documents",
  attachmentPath: "/attachments",
  attachmentTypePath: "/attachment-types",
  organisationsPath: "/organisations",
  caseDecisionsPath: "/case-decisions"
};
const ContentTypes = {
  ATTACHMENT_CONTENT_TYPE: "ATTACHMENT_CONTENT_TYPE",
  FILE_CONTENT_TYPE: "DATOTEKA",
  URL_CONTENT_TYPE: "URL"
};

export { ContentTypes };
export default Constants;
